<script>
  export default {
    props: {
      isOrderable: {
        type: Boolean,
        default: false
      },
      isAvailable: {
        type: Boolean,
        default: false
      },
      isBundle: {
        type: Boolean,
        default: false
      },
      isExamenBuddy: {
        type: Boolean,
        default: false
      },
      isSmall: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<template>
  <div
    :class="isSmall && 'product-stock-is-small'"
    class="flex flex-col text-base leading-relaxed lg:flex-row"
  >
    <template v-if="isOrderable && isAvailable">
      <span class="mr-1 font-bold text-green-600">
        Op voorraad.
      </span>
      <span
        v-if="!isExamenBuddy"
        class="text-gray-600"
      >
        Vandaag besteld, binnen 2 à 4 werkdagen in huis.
      </span>
    </template>
    <template v-else-if="isOrderable">
      <span class="mr-1 font-bold">
        Tijdelijk niet op voorraad.
      </span>
      <span class="text-gray-600">
        {{ isBundle ? 'Niet alle producten in dit pakket zijn op voorraad; deze worden later nageleverd.' : 'Dit product wordt nageleverd wanneer het weer op voorraad is.' }}
      </span>
    </template>
    <template v-else>
      <span class="mr-1 font-bold text-red-500">
        Niet op voorraad.
      </span>
      <span class="text-gray-600">
        {{ isBundle ? 'Deze producten zijn' : 'Dit product is' }} momenteel niet op voorraad.
      </span>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .product-stock-is-small {
    @apply text-xs;
    line-height: 12px;

    >span {
      @apply mb-3;
    }
  }
</style>
